import { Section } from '@all-hands-hq/plex-graphql-schema';
import { Card, CircularProgress, createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { GetDocumentToImportQuery } from '../../../../graphql/gen/types';
import { spacings } from '../../../../theme';
import { DocumentToImportAction, DocumentToImportState } from './documentToImportReducer';
import { GetDocumentToImportErrorView } from './GetDocumentToImportErrorView';
import { GoogleOutlinePreview } from './GoogleDocPreview';

export const PostGoogleDocPreview = ({
  data,
  loading,
  documentToImport,
  dispatch,
}: {
  data: GetDocumentToImportQuery | undefined;
  loading: boolean;
  documentToImport: DocumentToImportState | undefined;
  dispatch: React.Dispatch<DocumentToImportAction>;
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <Card className={classes.documentPreview}>
      {loading && <CircularProgress />}
      {data != null && <GetDocumentToImportErrorView data={data} />}

      {documentToImport != null && (
        <GoogleOutlinePreview
          document={documentToImport.document}
          selectedSections={[...documentToImport.selectedSections]}
          onSelectionRowClick={(section: Section): void => dispatch({ type: 'ROW_CLICK', section })}
          onSelectionCheckboxClick={(section: Section): void => dispatch({ type: 'CHECKBOX_CLICK', section })}
          onUpdateSelection={(selectedSections: Section[]): void => {
            dispatch({ type: 'UPDATE_SELECTION', selectedSections });
          }}
        />
      )}
    </Card>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    documentPreview: {
      marginTop: spacings.normal,
      padding: spacings.normal,
      textAlign: 'center',
    },
  })
);
